module.exports = __webpack_public_path__ + "static/media/AvatarMaestro.068caab7.jpg";